<script context="module">
    import { env } from '../Environment.svelte';
    export async function clientStoreSkuAvailability() {
        var CLIENT_STORE_SKU_AVAILABILITY =
            env[env.stage].apiMvno.url + '/getStores';
        var APIKEY = env[env.stage].apiMvno.key;

        let endpoint = CLIENT_STORE_SKU_AVAILABILITY;
        let headers = new Headers();
        headers.append('x-api-key', APIKEY);
        headers.append('Content-Type', 'application/json');

        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Error al consumir el servicio orderQuota');
                }
            })
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error;
            });
        return await resp;
    }
</script>
